import { observe } from 'mobx';
import * as React from 'react';
import { themeSettingsStore, ThemeSettingsStore } from '../theme-settings-store';

type UpdateType = 'new' | 'update';

type ThemeSettingsType = {
	type: UpdateType;
	store: ThemeSettingsStore;
};

export function useThemeSettings(): [ThemeSettingsType] {
	const [themeSettings, setThemeSettings] = React.useState({
		type: 'new' as UpdateType,
		store: themeSettingsStore
	});

	React.useEffect(() => {
		const disposer = observe(themeSettingsStore, () => {
			setThemeSettings({
				type: 'update',
				store: themeSettingsStore
			});
		});

		return () => disposer();
	}, []);

	return [themeSettings];
}
